export default {
  not_localised: 'Dit document is nog niet beschikbaar in jouw regio. De Engelse versie wordt getoond.',
};
